import React, { useCallback, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";

import Loader from "../../common/Loader";
import { PlatformSubscriptionDetail } from "../../common/platformTypes";
import { DocumentTabNav } from "../../components/DocumentTabNav";
import MenuBar from "../../components/MenuBar";
import { subscriptionInfo } from "../../services/api/Platform";
import { HistoryTab } from "./tabs/HistoryTab";
import { SubscriptionTab } from "./tabs/SubscriptionTab";

type Tab = "subscription" | "history";

export const PlatformSubscriptionPage: React.FunctionComponent<
  RouteComponentProps<{ subscriptionId: string }>
> = ({ match }) => {
  const subscriptionId = match.params.subscriptionId;
  const [tab, setTab] = useState<Tab>("subscription");
  const [detail, setDetail] = useState<PlatformSubscriptionDetail>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setDetail(await subscriptionInfo(subscriptionId));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }, [subscriptionId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <MenuBar />
      <div className="p-4">
        <h1>Platform Subscription</h1>
        <small className="text-monospace text-muted d-block mb-3">
          {subscriptionId}
        </small>
        <DocumentTabNav
          initialTab="subscription"
          tabs={[
            {
              id: "subscription",
              label: "Subscription",
              onClick: () => setTab("subscription"),
            },
            {
              id: "history",
              label: "History",
              onClick: () => setTab("history"),
            },
          ]}
        />
        <div className="mt-4">
          {loading ? (
            <Loader light />
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : !detail ? (
            <div className="alert alert-warning">Subscription not found</div>
          ) : tab === "subscription" ? (
            <SubscriptionTab subscription={detail.subscription} reload={load} />
          ) : (
            <HistoryTab trials={detail.trials} prior={detail.prior} />
          )}
        </div>
      </div>
    </div>
  );
};
